/*eslint-disable*/ export const messages = {
    'Add "{inputValue}"': ["„", ["inputValue"], "“ hinzufügen"],
    "All items have been removed.": "Alle Elemente wurden entfernt.",
    "Clear selection": "Auswahl löschen",
    "No results found.": "Keine Ergebnisse gefunden.",
    "Press Enter to select or deselect an option.":
        "Drücken Sie die Eingabetaste, um eine Option auszuwählen oder ihre Auswahl aufzuheben.",
    "Select All": "Alle auswählen",
    "Selected Items": "Ausgewählte Elemente",
    "Toggle menu": "Umschaltmenü",
    "listbox contents": "Listenfeldinhalte",
    "{itemAsString} has been removed.": [["itemAsString"], " wurde entfernt."],
    "{itemAsString} has been selected.": [["itemAsString"], " wurde ausgewählt."],
    "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.":
        [
            ["resultCount", "plural", { one: ["#", " Ergebnis ist"], other: ["#", " Ergebnisse sind"] }],
            " verfügbar, die Pfeile nach oben und nach unten für die Navigation verwenden. Zur Auswahl die Eingabetaste drücken.",
        ],
    "{selectedValue} selected": [["selectedValue"], " ausgewählt"],
    "{totalSelectedItems} selected": [["totalSelectedItems"], " ausgewählt"],
    "{totalSelectedItems} selected. Deselect all": [["totalSelectedItems"], " ausgewählt. Auswahl aufheben"],
    "{totalSelectedItems} selected. Select all {totalOptions} items": [
        ["totalSelectedItems"],
        " ausgewählt. Alle ",
        ["totalOptions"],
        "-Elemente auswählen",
    ],
};
